import { isVisible } from "@testing-library/user-event/dist/utils";
import "animate.css";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import welcomeAnimation from "../assets/Animation/welcome.json";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [
    "Web Developer",
    "Front-End Developer",
    "Back-End Developer",
  ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text, delta]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline">Welcome To My Portfolio</span>
                  <h1>
                    {`Hi! I'm Kamrul Hasan`}{" "}
                    <span
                      className="txt-rotate"
                      // dataPeriod="1000"
                      data-rotate='[ "Web Developer", "Front-End Developer", "Back-End Developer" ]'
                    >
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  <p>
                    Hi, I am a Full Stack Web Developer with prime focus on
                    JavaScript, TypeScript, ReactJS, NodeJS and have an active
                    interest in web development and web technologies as
                    well.Though, I started my career as an IT consultant at
                    Paradise Cables Ltd Bangladesh and my perpetual love for
                    programming and the web push me to do the challenges in this
                    field. I just love to solve problems,want to meet new
                    challenges and want to achieve as much as possible in this
                    field.
                  </p>
                </div>
              )}
            </TrackVisibility>
            <button className="vvd border p-3 rounded rounded-3">
              <a href="https://drive.google.com/file/d/160a2vTF8243Ntr9sTE4C_iZ0muAe8Ltc/view?usp=sharing">
                View Resume
              </a>
            </button>
          </Col>

          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              <Lottie
                className={isVisible ? "animate__animated animate__fadeIn" : ""}
                animationData={welcomeAnimation}
              />
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
